import { Stack, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";

export default function PublicationState({ status }) {
  return (
    <Stack
      direction="row"
      spacing="4px"
      sx={{
        ...getPublicationStateStyles({ status }),
        width: "fit-content",
        padding: "0 4px",
        borderRadius: "4px",
      }}
      alignItems="center"
    >
      {getPublicationStateIcon({ status })}
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "143%",
          letterSpacing: "0.17px",
          fontFamily: "Roboto",
          fontStyle: "normal",
        }}
      >
        {getPublicationStateLabel({ status })}
      </Typography>
    </Stack>
  );
}

function getPublicationStateLabel({ status }) {
  const label =
    status === "active"
      ? "Activa"
      : status === "paused"
      ? "Pausada"
      : "Inactiva";

  return label;
}

function getPublicationStateIcon({ status }) {
  const icon =
    status === "active" ? (
      <PlayArrowIcon
        sx={{
          fill: "#1B5E20",
          width: "24px",
          height: "24px",
        }}
      />
    ) : status === "paused" ? (
      <PauseIcon
        sx={{
          fill: "#464646",
          width: "24px",
          height: "24px",
        }}
      />
    ) : (
      <DoNotDisturbIcon
        sx={{
          fill: "#0000004D",
          width: "24px",
          height: "24px",
        }}
      />
    );

  return icon;
}

function getPublicationStateStyles({ status }) {
  const styles =
    status === "active"
      ? {
          backgroundColor: "#E1FCEF",
          color: "#1B5E20",
        }
      : status === "paused"
      ? {
          backgroundColor: "#F5F5F5",
          color: "#464646",
        }
      : {
          backgroundColor: "#0000001F",
          color: "#0000004D",
        };

  return styles;
}
